var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecommendedImage = function SvgRecommendedImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "recommended-image_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7 1.7h96.6v96.6H1.7z",
    style: {
      fill: "none"
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".recommended-image_svg__cls-6{fill:#4287c6}.recommended-image_svg__cls-8{fill:#fc5210}.recommended-image_svg__cls-10{fill:#8fe2ef}.recommended-image_svg__cls-11{fill:#f4d2a8}.recommended-image_svg__cls-12{fill:#89d8e5}.recommended-image_svg__cls-13{fill:#f2c58f}.recommended-image_svg__cls-20{fill:#ffdcb6}"))), /*#__PURE__*/React.createElement("g", {
    id: "recommended-image_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#recommended-image_svg__clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.3 50A48.3 48.3 0 1 0 50 98.3 48.3 48.3 0 0 0 98.3 50",
    style: {
      fill: "#a3cbe8"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M81 67.5H16.9l-5.44-28.59a11.8 11.8 0 0 1 11.59-14h51.76a11.8 11.8 0 0 1 11.59 14z",
    style: {
      fill: "#2f5782"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.4 80.7H20.61A13.15 13.15 0 0 1 7.46 67.43v-.65h85.09v.77A13.15 13.15 0 0 1 79.4 80.7",
    className: "recommended-image_svg__cls-6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.41 80.7h-5.49A13.15 13.15 0 0 1 5.08 70.36l-3.9-17.82A7.83 7.83 0 0 1 8.83 43H9a7.83 7.83 0 0 1 7.65 6.18zm53.18 0h5.49a13.15 13.15 0 0 0 12.84-10.34l3.89-17.81A7.83 7.83 0 0 0 91.17 43H91a7.83 7.83 0 0 0-7.65 6.18z",
    className: "recommended-image_svg__cls-6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.74 92.42h-4.62l4.12-11.72h7.37zm64.52 0h4.62L82.76 80.7h-7.37z",
    style: {
      fill: "#46586b"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m44.36 12.5-2 7.16c-1 4.88-1 6-3.22 5.83s6.11 5.57 12-.16z",
    className: "recommended-image_svg__cls-8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m57.8 12.5 2 7.16c1.29 4.55 1.57 5.45 3.22 5.83s-6.12 5.57-12-.16z",
    style: {
      fill: "#50050a"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m57.8 12.5 2 7.16c1.29 4.55 1.57 5.45 3.22 5.83s-6.12 5.57-12-.16z",
    className: "recommended-image_svg__cls-8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51 35a5.79 5.79 0 0 1-5.79-5.79v-2.74l-.71.12a9.3 9.3 0 0 0-2.21.66s-1.04 13.05-2.52 13.58l3.42 19.58 7.89 2.66V35z",
    className: "recommended-image_svg__cls-10"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51 35h.06v-9.5l-5.85 1v2.75A5.79 5.79 0 0 0 51 35",
    className: "recommended-image_svg__cls-10"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m37.22 32.72-3.28 8.34-4.86 9.56 4.36-.23 6.29-9.55v-.14.12c1.48-.53 2.54-13.58 2.54-13.58a9.32 9.32 0 0 0-5.09 5.48",
    className: "recommended-image_svg__cls-11"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.14 35a5.79 5.79 0 0 0 5.79-5.79v-2.74l.71.12a9.4 9.4 0 0 1 2.21.66s1.07 13.05 2.55 13.58L59 60.41l-7.89 2.66V35z",
    className: "recommended-image_svg__cls-12"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.14 35h-.06v-9.5l5.85 1v2.75A5.79 5.79 0 0 1 51.14 35",
    className: "recommended-image_svg__cls-12"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m64.95 32.72 3.28 8.34 4.86 9.56-4.36-.23-6.29-9.55v-.14.12c-1.48-.53-2.54-13.58-2.54-13.58a9.32 9.32 0 0 1 5.09 5.48",
    className: "recommended-image_svg__cls-13"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M44.08 17.41v3.43c0 3.82 2.81 7.9 6.62 7.9h.36V12.65z",
    className: "recommended-image_svg__cls-11"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.06 9.63v19.08c3.68-.25 7-4.18 7-7.87v-3.43z",
    className: "recommended-image_svg__cls-13"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.08 7.59H50c-3.26 0-5.9 3-5.9 6.7v3.12h.08c3 0 6.86-5.95 6.86-6.45z",
    className: "recommended-image_svg__cls-8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.08 7.59h1c3.26 0 5.9 3 5.9 6.7v3.12h-.08c-3 0-6.86-5.95-6.86-6.45z",
    className: "recommended-image_svg__cls-8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.58 7.59h-.36z",
    style: {
      fill: "#ff573d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.94 67.85-19-4.32c2.72.72 10.79 2.79 19 4.32",
    style: {
      fill: "#ffc78f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.91 63.54",
    style: {
      fill: "#af5182"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.61 69.76A11.3 11.3 0 0 1 31 66.6l3.54-1.3 2.16-2.14a4.32 4.32 0 0 1 3.66-.45l1.91.63a5 5 0 0 0 1.1.21l-1 2.37L44 68.14c-1.06.06-2 .08-2.93 0-1.81-.07-12.77 3-12.77 3a.9.9 0 0 1-.66-1.42",
    className: "recommended-image_svg__cls-13"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m43.42 63.55.83-1.87L65 55.48a10.35 10.35 0 0 1 7.8-.45h.07a4 4 0 0 1 2.62 4.34v.06a4 4 0 0 1-2.69 3.15l-.86.23-16.78 3.82A94 94 0 0 1 44 68.14l-1.59-2.22z",
    style: {
      fill: "#39c9c5"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70.39a3.82 3.82 0 0 0-1.74-2.57l-5.93-2.42-1.87-2.33c-1.24-.78-1.25-.53-2.65-.07l-2.31 1.12a5.5 5.5 0 0 1-1.24.24 5.08 5.08 0 0 1-.52 5l-.11.15c1.2.07 3.89.11 4.88.29C72.11 71.18 75 73 75 73c.79-.07 1.51-2 1-2.62m-7.13-23.82h-.08c-1.77.32-6.38 7.88-6.38 7.88l-.78-.44A8.13 8.13 0 0 0 56 52.78l-.53.09c-1 .24.51 3.3.51 3.3a5.2 5.2 0 0 0 4.12 3.2 4.82 4.82 0 0 0 3.4-.82l6.77-4.71 2.1-1.46c.52-.36 2.29-5.72-3.57-5.84",
    className: "recommended-image_svg__cls-11"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.69 66.51a5.1 5.1 0 0 0-.42-2.12l-.94-2.12-23.53-7a11.74 11.74 0 0 0-8.85-.51h-.08a4.48 4.48 0 0 0-3 4.92v.06a4.46 4.46 0 0 0 1.24 2.45c3.77 1.11 12.86 3.6 20.5 4.13a121 121 0 0 0 15.06.23",
    style: {
      fill: "#8ee0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.63 66.28c-7.64-.53-16.73-3-20.5-4.13 1 2.42 16.78 4.86 16.78 4.86l17 3.56.72-1 .11-.15a5.07 5.07 0 0 0 .94-2.9 121 121 0 0 1-15.06-.23",
    style: {
      fill: "#28cece"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.51 56.11a60 60 0 0 1 5.61-3.33A8.13 8.13 0 0 0 40.53 54l-.77.49s-4.61-7.56-6.38-7.88h-.08c-5.86.12-4.09 5.48-3.57 5.84l2.1 1.46c3.34 1.74 8.35 2.65 8.68 2.25",
    className: "recommended-image_svg__cls-20"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m46.67 52.88-.55-.09a60 60 0 0 0-5.61 3.33c-.33.4-5.34-.51-8.68-2.25l6.76 4.71a4.82 4.82 0 0 0 3.4.82 5.2 5.2 0 0 0 4.12-3.21s1.55-3.06.51-3.3",
    className: "recommended-image_svg__cls-20"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51 9.63a6.88 6.88 0 0 0-6.88 6.88v1h7V9.63z",
    style: {
      fill: "#ff7d4a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 16.51a6.88 6.88 0 0 0-6.9-6.88H51v7.89h7z",
    style: {
      fill: "#ff642e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.66 59.81H64.4v1.74H37.66z",
    style: {
      fill: "#101d2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1 41.21H39a1.25 1.25 0 0 0-1.3 1.2v17.36L64 41.52a1.35 1.35 0 0 0-.86-.3",
    style: {
      fill: "#91a2af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 41.52 37.66 59.77H64.4V42.41a1.15 1.15 0 0 0-.44-.89",
    style: {
      fill: "#798e9b"
    }
  })));
};
export default SvgRecommendedImage;